import INFO from "./user";
import { CANONICAL_URL, DEFAULT_IMAGE } from "./seo";
import { getProjectPath, getProjectSlug } from "./projectUtils";

const absoluteUrl = (path = "/") =>
	`${CANONICAL_URL}${path.startsWith("/") ? path : `/${path}`}`;

const personSchema = {
	"@context": "https://schema.org",
	"@type": "Person",
	name: INFO.main.name,
	jobTitle: INFO.main.role,
	email: INFO.main.email,
	url: CANONICAL_URL,
	image: absoluteUrl(DEFAULT_IMAGE),
	address: {
		"@type": "PostalAddress",
		addressLocality: "Islamabad",
		addressCountry: "PK",
	},
	sameAs: [
		INFO.socials.github,
		INFO.socials.linkedin,
		INFO.socials.medium,
		INFO.socials.npm,
		INFO.socials.linktree,
	].filter(Boolean),
	knowsAbout: [
		"React",
		"Node.js",
		"Full-stack web development",
		"SaaS development",
		"AI integrations",
		"Database design",
	],
};

const websiteSchema = {
	"@context": "https://schema.org",
	"@type": "WebSite",
	name: INFO.main.name,
	url: CANONICAL_URL,
	description: INFO.homepage.description,
	publisher: {
		"@type": "Person",
		name: INFO.main.name,
	},
};

const serviceSchema = {
	"@context": "https://schema.org",
	"@type": "ItemList",
	name: "Full-stack development services",
	itemListElement: INFO.services.map((service, index) => ({
		"@type": "ListItem",
		position: index + 1,
		item: {
			"@type": "Service",
			name: service.title,
			description: service.description,
			provider: {
				"@type": "Person",
				name: INFO.main.name,
			},
			areaServed: "Pakistan and remote clients",
		},
	})),
};

const projectListSchema = {
	"@context": "https://schema.org",
	"@type": "ItemList",
	name: "Selected full-stack projects by Sharjeel Faiq",
	itemListElement: INFO.projects.map((project, index) => ({
		"@type": "ListItem",
		position: index + 1,
		url: absoluteUrl(getProjectPath(project)),
		name: project.title,
	})),
};

const buildProjectSchema = (project) => ({
	"@context": "https://schema.org",
	"@type": "CreativeWork",
	name: project.title,
	description: project.description,
	url: absoluteUrl(getProjectPath(project)),
	creator: {
		"@type": "Person",
		name: INFO.main.name,
	},
	keywords: project.stack.join(", "),
	sameAs: [project.live, project.github].filter(Boolean),
	identifier: getProjectSlug(project),
});

export {
	absoluteUrl,
	buildProjectSchema,
	personSchema,
	projectListSchema,
	serviceSchema,
	websiteSchema,
};
